"use strict";

// Работа с локальным хранилищем.

var storage = window.localStorage;

function has(key) {
    return storage.hasOwnProperty(key);
}

function get(key) {
    var raw = storage.getItem(key);
    return JSON.parse(raw);
}

function set(key, value) {
    var raw = JSON.stringify(value);
    return storage.setItem(key, raw);
}

function remove(key) {
    return storage.removeItem(key);
}

export default {
    has: has,
    get: get,
    set: set,
    remove: remove,
};
